/**
 * Shopify native Customer Privacy / cookie consent integration.
 *
 * The official banner UI, copy, styling, and regulation logic are owned by Shopify
 * (Admin → Settings → Customer privacy) and injected via {{ content_for_header }}.
 * This file does NOT render a custom cookie bar or call privacyBanner.loadBanner().
 *
 * @see https://shopify.dev/docs/api/customer-privacy
 */
(function () {
  'use strict';

  var CONSENT_FEATURE = { name: 'consent-tracking-api', version: '0.1' };

  /** DOM markers for Shopify’s injected privacy banner (shopify-pc = privacy consent). */
  var NATIVE_BANNER_SELECTOR =
    '#shopify-pc__banner__dialog, [id^="shopify-pc__"], .shopify-pc__banner__dialog, [data-shopify-privacy-banner]';

  /* --- Theme cookie helpers (used by age-verification-popup.js, newsletter-popup.js) --- */

  window.setCookie = function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  };

  window.getCookie = function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
    }
    return null;
  };

  window.eraseCookie = function eraseCookie(name) {
    document.cookie = name + '=; Max-Age=-99999999; path=/';
  };

  /* --- Native privacy bridge --- */

  function dispatch(name, detail) {
    document.dispatchEvent(
      new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        cancelable: false,
      })
    );
  }

  function hasNativeBannerNode() {
    return !!document.querySelector(NATIVE_BANNER_SELECTOR);
  }

  function readPrivacySnapshot(customerPrivacy) {
    var cp = customerPrivacy;
    var snapshot = {
      region: safeCall(cp, 'getRegion'),
      regulation: safeCall(cp, 'getRegulation'),
      isRegulationEnforced: safeCall(cp, 'isRegulationEnforced'),
      shouldShowBanner: safeCall(cp, 'shouldShowBanner'),
      saleOfDataRegion: safeCall(cp, 'saleOfDataRegion'),
      consent: safeCall(cp, 'currentVisitorConsent'),
      marketingAllowed: safeCall(cp, 'marketingAllowed'),
      analyticsAllowed: safeCall(cp, 'analyticsProcessingAllowed'),
      preferencesAllowed: safeCall(cp, 'preferencesProcessingAllowed'),
      saleOfDataAllowed: safeCall(cp, 'saleOfDataAllowed'),
      nativeBannerInDom: hasNativeBannerNode(),
      privacyBannerAvailable: typeof window.privacyBanner !== 'undefined',
    };

    if (window.Shopify && window.Shopify.customerPrivacyConfig) {
      snapshot.adminConfigPresent = true;
    }

    return snapshot;
  }

  function safeCall(obj, method) {
    if (!obj || typeof obj[method] !== 'function') return null;
    try {
      return obj[method]();
    } catch (e) {
      return null;
    }
  }

  function whenCustomerPrivacy(callback) {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      callback(window.Shopify.customerPrivacy);
      return;
    }

    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      return;
    }

    window.Shopify.loadFeatures([CONSENT_FEATURE], function (error) {
      if (error || !window.Shopify.customerPrivacy) return;
      callback(window.Shopify.customerPrivacy);
    });
  }

  function watchNativeBannerRender(customerPrivacy) {
    if (hasNativeBannerNode()) {
      dispatch('shopify:privacy:banner-rendered', readPrivacySnapshot(customerPrivacy));
      return;
    }

    if (typeof MutationObserver === 'undefined') return;

    var bannerReported = false;
    var observer = new MutationObserver(function () {
      if (bannerReported || !hasNativeBannerNode()) return;
      bannerReported = true;
      observer.disconnect();
      dispatch('shopify:privacy:banner-rendered', readPrivacySnapshot(customerPrivacy));
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      observer.disconnect();
    }, 60000);
  }

  function initNativePrivacyBridge(customerPrivacy) {
    var snapshot = readPrivacySnapshot(customerPrivacy);

    dispatch('shopify:privacy:ready', snapshot);

    document.addEventListener('visitorConsentCollected', function (event) {
      dispatch('shopify:privacy:consent', {
        visitorConsent: event.detail || null,
        state: readPrivacySnapshot(customerPrivacy),
      });
    });

    watchNativeBannerRender(customerPrivacy);
  }

  function bootstrap() {
    whenCustomerPrivacy(initNativePrivacyBridge);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
